import { toastr } from "react-redux-toastr";
import Api from "../../utils/config/api";
import { SET_STORE_DETAILS, RESET_ONBOARDING_STATE } from "../types";

export const resetOnboardState = () => (dispatch) => {
  dispatch({
    type: RESET_ONBOARDING_STATE,
  });
};

export const setStoreCall = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/onboarding", data)
      .then((res) => {
        dispatch({
          type: SET_STORE_DETAILS,
          payload: res.data.payload,
        });
        return resolve(res.data, "store updated successfully");
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getIndustries = () => () => {
  return new Promise((resolve, reject) => {
    Api.get("/v1/onboarding/seed/industry")
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getPosSeed = () => () => {
  return new Promise((resolve, reject) => {
    Api.get("/v1/onboarding/seed/pos")
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getAddressCall = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/utility/reverse-geocode", data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getImageKeyCall = (data, campaignId) => () => {
  return new Promise((resolve, reject) => {
    Api.post(
      `/v1/utility/image-upload${
        campaignId ? `?campaignId=${campaignId}` : ""
      }`,
      data
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 413) {
          toastr.error(
            "Upload Failed",
            err?.response?.data?.message ||
              "Please upload image under 10mb size."
          );
          return reject(err?.response?.data?.message);
        } else if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error("Upload Failed", errObj.msg)
          );
          return reject(err);
        } else {
          toastr.error(
            "Upload Failed",
            err?.response?.data?.message || "Try uploading the image again."
          );
          return reject(err);
        }
      });
  });
};

export const getUserOnboarding = (userId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/onboarding/${userId}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
